import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";

export class Carousel2Component extends AlpineComponent {
    // Debounce timer property
    private updatePagingTimeout: number | null = null;

    public contentScrollContainer: HTMLElement | null | undefined = null;
    public pagerScrollContainer: HTMLElement | null | undefined = null;
    public firstVisibleElement: HTMLElement | null = null;
    public prev: HTMLElement | null = null;
    public next: HTMLElement | null = null;
    public totalPages: number | null = null;
    public currentPage: number | null = null;
    public scrollPositions: Array<HTMLElement> = [];

    constructor() {
        super();        
    }

    protected container = this.binding({
        ["x-resize"]() {
            this.updatePaging();
        },
        ["x-on:scroll.passive"]() {
            this.debouncedUpdatePaging();
        }
    });

    protected nextButton = this.binding({
        ["x-on:click"]() {
            this.scrollToElement(this.next);
        }
    });
    protected prevButton = this.binding({
        ["x-on:click"]() {
            this.scrollToElement(this.prev);
        },
        
    });

    init(): void {
        if (!this.contentScrollContainer) {
            this.contentScrollContainer = this.$refs['contentContainer'];
        }

        if (!this.pagerScrollContainer) {
            this.pagerScrollContainer = this.$refs['pagerContainer'];
        }
        this.updatePaging();
    }

    // Debounced wrapper for updatePaging
    debouncedUpdatePaging(): void {
        if (this.updatePagingTimeout !== null) {
            clearTimeout(this.updatePagingTimeout);
        }
        this.updatePagingTimeout = window.setTimeout(() => {
            this.updatePaging();
        }, 50);
    }

    updatePaging(): void {
        if (!this.contentScrollContainer) return;

        const totalElements = this.contentScrollContainer.children.length;

        const containerRect = this.contentScrollContainer.getBoundingClientRect();
        const visibleElements = Array.from(this.contentScrollContainer.children).filter((child) => {
            const childRect = child.getBoundingClientRect();
            return childRect.left >= containerRect.left && childRect.right <= containerRect.right;
        });

        const totalVisibleElements = visibleElements.length;
        if (totalVisibleElements === 0) {
            this.totalPages = 1;
            this.currentPage = 1;
            return;
        }

        this.totalPages = Math.ceil(totalElements / totalVisibleElements);

        this.firstVisibleElement = visibleElements[0] as HTMLElement;
        // Figure out the current page
        const firstVisibleIndex = Array.from(this.contentScrollContainer.children).indexOf(visibleElements[0]);

        this.currentPage = Math.floor(firstVisibleIndex / totalVisibleElements) + 1;


        for (let pageZeroBased = 0; pageZeroBased < this.totalPages; pageZeroBased++) {
            const index = pageZeroBased * (totalVisibleElements || 1);
            if (index < this.contentScrollContainer.children.length) {
                this.scrollPositions[pageZeroBased] = this.contentScrollContainer.children[index] as HTMLElement;
            }
        }

        const firstVisibleItem = this.contentScrollContainer.children.item(firstVisibleIndex) as HTMLElement;
        const itemAtScrollPosition = this.scrollPositions[this.currentPage-1];

        if (firstVisibleItem != itemAtScrollPosition) {
            // This means we couldn't scroll all the way to the next page, so adjust the current page
            this.currentPage = this.totalPages;
        }

        this.prev = this.currentPage == 1 ? null : this.scrollPositions[this.currentPage - 2];
        this.next = this.currentPage == this.totalPages ? null : this.scrollPositions[this.currentPage];
    }

    //update(): void {
    //    if (this.containerEl === undefined) return;

    //    this.numberOfElements = this.containerEl.children.length;

    //    const containerRect = this.containerEl.getBoundingClientRect();
    //    const visibleElements = Array.from(this.containerEl.children).filter((child) => {
    //        const childRect = child.getBoundingClientRect();
    //        return childRect.left >= containerRect.left && childRect.right <= containerRect.right;
    //    });
    //    this.numberVisibleElements = visibleElements.length;
    //    if (visibleElements.length > 0) {
    //        this.numberOfPages = Math.ceil(this.numberOfElements / this.numberVisibleElements);
    //        const firstVisibleIndex = Array.from(this.containerEl.children).indexOf(visibleElements[0]);
    //        this.currentPage = Math.floor(firstVisibleIndex / this.numberVisibleElements) + 1;
    //    } else {
    //        this.numberOfPages = 1;
    //        this.currentPage = 1;
    //    }

    //    for(let i = 0; i < this.numberOfPages; i++) {
    //        const index = i * (this.numberVisibleElements || 1);
    //        if (index < this.containerEl.children.length) {
    //            this.scrollPositions[i] = this.containerEl.children[index] as HTMLElement;
    //        }
    //    }

    //    this.prev = this.currentPage == 1 ? null : this.scrollPositions[this.currentPage - 2];
    //    this.next = this.currentPage == this.numberOfPages ? null : this.scrollPositions[this.currentPage];
    //}
    scrollToElement(element : HTMLElement) {
        if (!this.contentScrollContainer || !element || !this.firstVisibleElement) return;

        const computedStyle = getComputedStyle(element);
        const firstElementComputedStyle = getComputedStyle(this.scrollPositions[0]);

        this.contentScrollContainer.scrollTo({
            behavior: 'smooth',
            left: element.offsetLeft - parseInt(computedStyle.marginLeft) - parseInt(firstElementComputedStyle.marginLeft)
        });
    };
    scrollToRef(refName: string) {
        const element = this.$refs[refName];
        if (!element) return;

        this.firstVisibleElement = element; // This allows paging to update immediately

        this.scrollToElement(element);

        // Scroll the pager to center the active page

        const pageElement = this.$refs['page_' + refName];
        if (!this.pagerScrollContainer || !pageElement) return;

        //// Calculate the center position
        //const pagerRect = this.pagerContainerEl.getBoundingClientRect();
        //const pageRect = pageElement.getBoundingClientRect();

        //// Current scroll position of the pager container
        //const currentScrollLeft = this.pagerContainerEl.scrollLeft;

        // Calculate the offset needed to center the pageElement
        const pageElementCenter = pageElement.offsetLeft + (pageElement.offsetWidth / 2);
        const targetScrollLeft = pageElementCenter - (this.pagerScrollContainer.offsetWidth / 2);

        this.pagerScrollContainer.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });
    }

    scrollToPage(pageNumber: number) {
        if (pageNumber > (this.totalPages ?? 1) || pageNumber < 1) return;
        this.currentPage = pageNumber;
        if (!this.contentScrollContainer || !this.scrollPositions[pageNumber - 1] || !this.firstVisibleElement) return;
        const element = this.scrollPositions[pageNumber - 1];
        this.scrollToElement(element);
    }
}